/**
 * Public links used by Settings → Support. Set these in apps/web/.env when the
 * real values exist (see apps/site/site.config.json):
 *   VITE_SITE_URL       landing site, hosts /legal/terms.html and /legal/privacy.html
 *   VITE_SUPPORT_EMAIL  support mailbox shown under Help & Support
 */
const env = import.meta.env as Record<string, string | undefined>;

export const SITE_URL = (env['VITE_SITE_URL'] ?? 'https://getloomia.site').replace(/\/+$/, '');
export const SUPPORT_EMAIL: string | null = env['VITE_SUPPORT_EMAIL']?.trim() || null;
